<i18n src="@/i18n/components/app.json"></i18n>

<template>
  <div id="app">
    <nav class="navbar has-shadow">
      <div class="navbar-brand">
        <router-link to="/" exact class="navbar-item">
          <img src="./assets/logo.svg" alt="Freatle" width="112" height="28">
        </router-link>
        <div class="navbar-burger burger" :class="{ 'is-active': isNavbarOpen }" @click="toggleNavbar">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div class="navbar-menu" :class="{ 'is-active': isNavbarOpen }">
        <div class="navbar-start">
          <router-link to="/" exact class="navbar-item is-tab">{{ $t('home') }}</router-link>
          <router-link :to="'/event/' + demoEventId" exact class="navbar-item is-tab">{{ $t('demo') }}</router-link>
          <router-link to="/help" exact class="navbar-item is-tab">{{ $t('help') }}</router-link>
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <div class="field is-grouped is-grouped-multiline">
              <p class="control">
                <a href="https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=RA8SPLMLG97DL" target="_blank" rel="noopener" class="button is-primary is-outlined">
                  <span class="icon is-small"><i class="fa fa-paypal"></i></span>
                  <span>{{ $t('donate') }}</span>
                </a>
              </p>

              <p class="control">
                <language-switcher></language-switcher>
              </p>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <section class="hero is-danger">
      <div class="hero-body" style="padding-top:8px;padding-bottom:8px">
        <div class="container has-text-centered">
          <span v-html="$t('notice')" />
        </div>
      </div>
    </section>

    <router-view></router-view>

    <footer class="footer">
      <div class="container">
        <div class="content has-text-centered">
          <p>
            <strong>Freatle</strong> {{ $t('by') }} <a href="https://pulsar.surge.sh/">Pulsar</a>. {{ $t('copyright') }}.
          </p>
          <p>
            <a href="https://github.com/pulsardev">
              <span class="icon"><i class="fa fa-lg fa-github"></i></span>
            </a>
          </p>
        </div>

        <div class="content has-text-centered">
          <!-- Sharingbutton Facebook -->
          <a
            class="button is-info is-small"
            href="https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Ffreatle.com%2F"
            target="_blank"
            aria-label="Share on Facebook"
          >
            <b-icon pack="fa" icon="facebook" size="is-small"></b-icon>
            <span>{{ $t('shareFacebook') }}</span>
          </a>

          <!-- Sharingbutton Twitter -->
          <a
            class="button is-primary is-small"
            href="https://twitter.com/intent/tweet/?text=Freatle%20-%20Qui%20ram%C3%A8ne%20quoi%20%3F&amp;url=https%3A%2F%2Ffreatle.com%2F"
            target="_blank"
            aria-label="Share on Twitter"
          >
            <b-icon pack="fa" icon="twitter" size="is-small"></b-icon>
            <span>{{ $t('shareTwitter') }}</span>
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import { bus } from '@/shared/bus'
  import headful from 'headful'
  import LanguageSwitcher from './components/LanguageSwitcher.vue'

  export default {
    name: 'app',
    components: {
      LanguageSwitcher
    },
    mounted () {
      bus.$on('toast:new', toast => this.addToast(toast))

      headful({
        title: 'Freatle - ' + this.$t('headTitle'),
        description: this.$t('headDescription')
      })
    },
    data () {
      return {
        demoEventId: process.env.DEMO_EVENT_ID,
        isNavbarOpen: false
      }
    },
    methods: {
      toggleNavbar () {
        this.isNavbarOpen = !this.isNavbarOpen
      },
      addToast (toast) {
        if (!toast.message) {
          switch (toast.type) {
            case 'danger':
              toast.message = this.$t('genericError')
              break
            case 'warning':
              toast.message = this.$t('genericWarning')
              break
            default:
              toast.message = this.$t('genericError')
          }
        }

        let toastOptions = {
          message: toast.message,
          position: 'is-bottom'
        }

        if (toast.type) {
          toastOptions.type = 'is-' + toast.type
        }

        this.$toast.open(toastOptions)
      }
    }
  }
</script>

<style lang="scss">
  @import './assets/scss/design.scss';
  @import './assets/css/nprogress/nprogress.css';

  html {
    background-color: whitesmoke;
  }

  .navbar-item.is-tab {
    display: flex;
    align-items: center;
  }

  .hero.is-warning {
    background-color: #fac564;
  }

  /* [Buefy] */

  .loading-overlay .loading-background {
    background: rgba(255, 255, 255, 0.2);
  }

  .loading-overlay .loading-icon:after {
    border: 2px solid #00d1b2;
    border-radius: 290486px;
    border-right-color: transparent;
    border-top-color: transparent;
  }

  /* [BEM components] */

  .c-background--image {
    background: url('./assets/imgs/food.png') center;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue